import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {sendMobileAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {PAYPAL_BUTTON_POSITION, PURCHASE_STORAGE} from 'constants/analytics';
import {CART_BUTTON} from 'constants/analytics/events/cart';
import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';

import {PAYPAL_PURCHASE_STORAGE} from 'constants/session';

import {logWithSentry} from 'libs/sentry/sentry';
import {sessionStore} from 'libs/storage/storage';

/**
 * handleErrorAnalytic
 */
export const handlePayPalDesktopErrorAnalytic = (
    error: Record<string, unknown>,
    isSentry = false,
) => {
    const placeOfInteraction = sessionStore.get(PAYPAL_PURCHASE_STORAGE);
    if (placeOfInteraction === 'Checkout') {
        sendDesktopAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: `Error – ${error.message}`,
                method: 'PayPal',
            },
            false,
        );
    } else if (placeOfInteraction === 'Cart') {
        sendDesktopAnalyticsEvent(
            CART_BUTTON,
            {
                action: 'Right Section - PayPal Express',
                label: `Error – ${error?.message}`,
            },
            false,
        );
    }
    if (isSentry) {
        logWithSentry(error as unknown as Error, 'PaypalV3: Error in SDK');
    }
};

/**
 * handleErrorAnalytic
 */
export const handlePayPalMobileErrorAnalytic = (error: Record<string, unknown>) => {
    const placeOfInteraction = sessionStore.get(PURCHASE_STORAGE);
    const buttonPosition = sessionStore.get(PAYPAL_BUTTON_POSITION);
    if (placeOfInteraction === 'Checkout') {
        sendMobileAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: `Error – ${error.message}`,
                method: 'PayPal',
            },
            false,
        );
    } else if (placeOfInteraction === 'Cart') {
        sendMobileAnalyticsEvent(
            CART_BUTTON,
            {
                action: `${buttonPosition} Section - PayPal Express`,
                label: `Error – ${error?.message}`,
            },
            false,
        );
    }
};
